import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import baseUrl from "../../baseUrl";
import { parseJwt } from "../../utils/parseJwt";
import Spinner from "../Spinner/Spinner";

const UserProfile = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  const [userInfo, setUserInfo] = useState({});
  const [avatar, setAvatar] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const userId = parseJwt(token).id;
    axios
      .post(
        `${baseUrl}/user/profile`,
        { id: userId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          setAvatar(res.data.user.avatar["url"]);
          setUserInfo(res.data.user);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);
  return (
    <>
      {loading && <Spinner />}
      <div className="h-full mt-5">
        <span className="text-2xl ml-5 font-semibold block">User Profile</span>
        <div className="border-b-2 block md:flex">
          <div className="w-full md:w-2/5 div-4 sm:div-6 lg:div-8 bg-white shadow-md">
            <div className="flex justify-between"></div>
            <div className="w-full div-8 mx-2 flex justify-center">
              <img
                id="showImage"
                className="items-center border"
                style={{
                  borderRadius: "50%",
                  width: "400px",
                  height: "400px",
                }}
                src={avatar}
                alt="user_pic"
              />
            </div>
          </div>
          <div className="w-full md:w-3/5 div-8 bg-white lg:ml-4 shadow-md">
            <div className="rounded shadow div-6">
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Full Name
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.fullName}
                  </div>
                </div>
              </div>
              <div className="pb-4">
                <label
                  htmlFor="about"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Email
                </label>
                <div className="border-1 rounded-r px-4 py-2 w-full">
                  {userInfo.email}
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Phone Number
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    +977-{userInfo.phoneNumber}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Address
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.address}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Date of Birth
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {moment(userInfo.dob).format("MMMM Do YYYY")}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Gender
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.gender}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Verified
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.emailVerified ? "Yes" : "No"}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Profile Created At
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {moment(userInfo.createdAt).fromNow()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
